import React from 'react';
import { LessonData } from '../../types';
import ActionItems from '../ActionItems/ActionItems';

// Styles
import '@ramsey-design-system/button/dist/button.css';
import '@ramsey-design-system/progress-bar/dist/progress-bar.css';
import styles from './user-lesson-overview.module.css';

type UserLessonOverviewProps = {
  lessonData: LessonData;
  lessonNumber?: string;
  showStepper?: boolean;
  stepperBackgroundColor?: string;
  courseTitleColor?: string;
  actionItemsTitle?: string;
  truncateActionItemText?: boolean;
  collapsedActionGroupId?: string;
  showLock?: boolean;
  disableActionItem?: boolean;
  showLessonTags?: boolean;
  titleColor?: string;
  notificationBanner?: JSX.Element;
  showVideoItems?: boolean;
  chevronRightIcon?: boolean;
};

const renderActionGroups = ({
  lessonData,
  actionItemsTitle,
  collapsedActionGroupId,
  showStepper,
  stepperBackgroundColor,
  showLessonTags,
  showVideoItems,
  chevronRightIcon,
}: UserLessonOverviewProps) => {
  const actionGroups = [...lessonData.action_groups];

  function anyVideosCompleted(): boolean {
    let isLocked = false;

    actionGroups.map(actionGroup => {
      actionGroup.action_items.map(item => {
        if (item.template === 'lesson-video' && !item.complete) {
          isLocked = true;
        }
        return false;
      });
    });
    return isLocked;
  }

  return actionGroups.map((actionGroup, index, allItems) => {
    const hideTitle = false;
    const isLastActionGroup = allItems.length === index + 1;
    const collapse = actionGroup.id === collapsedActionGroupId;

    return (
      <ActionItems
        key={index}
        lessonNumber={lessonData.subtitle}
        actionGroup={actionGroup}
        showTitle={hideTitle}
        title={actionItemsTitle}
        truncateText={true}
        className={styles.action_item_container}
        collapse={collapse}
        showStepper={showStepper}
        stepperBackgroundColor={stepperBackgroundColor}
        showLessonTag={showLessonTags}
        isLastActionGroup={isLastActionGroup}
        showLock={anyVideosCompleted()}
        disableActionItem={anyVideosCompleted()}
        showVideoItems={showVideoItems}
        chevronRightIcon={chevronRightIcon}
      />
    );
  });
};

function UserLessonOverview({
  lessonData,
  showStepper = true,
  stepperBackgroundColor = '#fff',
  actionItemsTitle,
  truncateActionItemText,
  collapsedActionGroupId = 'multi-survey',
  disableActionItem,
  showLessonTags = false,
  titleColor = '',
  showLock,
  notificationBanner,
  showVideoItems = true,
  chevronRightIcon,
}: UserLessonOverviewProps) {
  if (!lessonData) return null;

  const { title } = lessonData;

  const itemWrapperClassNames = `${styles.item_wrapper}`;

  const setTitleColor = { color: titleColor };

  return (
    <>
      <div
        className={itemWrapperClassNames}
        data-testid="action-item-container"
      >
        {notificationBanner}
        <h2
          className={styles.title}
          style={setTitleColor}
          data-testid="user-lesson-overview-title"
        >
          {`${title} To Do List`}
        </h2>
        {renderActionGroups({
          lessonData,
          actionItemsTitle,
          truncateActionItemText,
          collapsedActionGroupId,
          showLock,
          showStepper,
          stepperBackgroundColor,
          disableActionItem,
          showLessonTags,
          showVideoItems,
          chevronRightIcon,
        })}
      </div>
    </>
  );
}

export default UserLessonOverview;
